import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';
import { type StreamlineFontSizeType, streamlineFontSizes } from './constants';

export interface StreamlineIconProps extends SvgIconProps {
  size?: StreamlineFontSizeType;
}

export const StreamlineIcon = ({ size, sx, ...rest }: StreamlineIconProps) => {
  const iconSize = size
    ? `${streamlineFontSizes(size)} !important`
    : '1em !important';

  return (
    <SvgIcon
      {...rest}
      sx={{
        verticalAlign: size ? '-0.125rem' : undefined,
        height: iconSize,
        width: 'auto !important',
        fontSize: iconSize,
        transition: 'transform 0.3s ease-in-out',
        ...sx,
      }}
    />
  );
};
